function myProfile() {
    this.data={};
    this.data_old={};
    this.profObj={};
    this.timeHandlerIndex={};
    this.showGirlData={};
    this.wasUpdated=0;
    this.timeHandlerIndexBeltDown={};
    this.bonusTimeObj={};
}
myProfile.prototype={
    init:function(){
        this.profObj=$("#profileBelt");
        this.timeHandlerIndex["mission"]=_externalTimeHandler.getNewIndex();
        this.timeHandlerIndex["message_flag"]=_externalTimeHandler.getNewIndex();
        this.timeHandlerIndex["energy_belts"]={
            "cash":[_externalTimeHandler.getNewIndex(),_externalTimeHandler.getNewIndex()],
            "skill":[_externalTimeHandler.getNewIndex(),_externalTimeHandler.getNewIndex()],
            "position":[_externalTimeHandler.getNewIndex(),_externalTimeHandler.getNewIndex()],
            "fight":[_externalTimeHandler.getNewIndex(),_externalTimeHandler.getNewIndex()]
        };
        
        this.initIconsBeltDown();
        this.initIconsFlow();
        _beltRightDown.init();
    },
    makeAnim:function(obj,index,conf){
        if(obj.throwDown(_externalTimeHandler,index,conf)){
//             _mySound.playSound("hover");
        }
    },
    initIconsBeltDown:function(){
        var thc=this;
        $("#mainButtonsBar .row .iconJS").each(function(){
           var type=$(this).attr('data-type');
           thc.timeHandlerIndexBeltDown[type]=_externalTimeHandler.getNewIndex();
        });
        $("#mainButtonsBar .iconJSTrigger").on("mouseenter",function(){
            var th=$(this),obj=th.find(".iconJS"),type=obj.attr("data-type");
            thc.makeAnim(obj,thc.timeHandlerIndexBeltDown[type],{v_arr:[4.15,2.8,1.2]});
        });
    },
    initIconsFlow:function(){
        var timeIndex={},thc=this;
        
        this.profObj.find(".iconJSTrigger .iconJS").each(function(){
           var type=$(this).attr('data-type');
           timeIndex[type]=_externalTimeHandler.getNewIndex();
        });
        this.profObj.find(".iconJSTrigger").on("mouseenter",function(){
            var th=$(this),obj=th.find(".iconJS"),type=obj.attr("data-type");
            thc.makeAnim(obj,timeIndex[type],{v_arr:[3.5,2.5,1]});
        });
    },
    updateData:function(data){
        var i,name,data_keys=["level","login_str","cash","time_update","energy","energy_max","premium","premium_free",
        "skill_energy","position_energy","fight_energy","cash_energy","mission_flag","speed_bonus_global_flo"];
        
        for(i in data_keys){
            name=data_keys[i];
            if(typeof data[name]!="undefined"){
               this.setData(name,data[name]);
            }
        }
        if(typeof data.premium!=="undefined" || typeof data.premium_free!=="undefined" ){
            this.setData("premium_all",this.takeData("premium_all"));
        }
        
        this.makeBeltAnimation();
        this.data_old=copyObj(this.data);
        this.wasUpdated=1; 
        var bum;
        if(typeof data.girls_was_show !="undefined"){
            for(i in data.girls_was_show){
                bum=data.girls_was_show[i];
                this.showGirlData[bum.girl_id]=copyObj(bum);
            }
            this.updateGirlShow();
        }
        if(typeof data.message_flag !="undefined"){
            this.updateErrorReporting(intval(data.message_flag));
        }
        if(typeof data.timeBonusObj!="undefined"){
            if(!compareTwoObj(this.bonusTimeObj,data.timeBonusObj)){
                this.bonusTimeObj=copyObj(data.timeBonusObj);
                _beltRightDown.update();
            }
        }
    },
    updateErrorReporting:function(active){
        var handlerIsSet=_externalTimeHandler.isIndexSet(this.timeHandlerIndex["message_flag"]);
        if(!active){
            if(handlerIsSet){
                _externalTimeHandler.clear(this.timeHandlerIndex["message_flag"]);
            }
        }
        else if(!handlerIsSet){
            var obj=$("#mainErrorReporting"),step=0;
            obj.attr("action","bugsall");
            _externalTimeHandler.set(this.timeHandlerIndex["message_flag"],function(){
                step=(step+1)%2;
                if(step){
                    obj.addClass("hover");
                }
                else{
                    obj.removeClass("hover");
                }
            },1000,function(){
                obj.attr("action","bugs").removeClass("hover");
            });
        }
        //
        
    },
    takeShowGirlData:function(){
        return copyObj(this.showGirlData);
    },
    updateGirlShow:function(){
        var i,bum,show="stop";
        for(i in this.showGirlData){
            bum=this.showGirlData[i];
            if(bum.was_show==0){
                show="start";
            }
        }
        this.iconsBeltDownActiveAnim("map",show);
    },
    iconsBeltDownActiveAnim:function(type,state_str){
        var obj=$("#mainButtonsBar .row .iconJS[data-type='"+type+"']").closest(".row");
        var is_active=obj.attr("data-active");
        if(typeof is_active=="undefined"){
            is_active=0;
        }
        is_active=intval(is_active);
        if(state_str=="start" && is_active==0){
            _externalTimeHandler.clear(this.timeHandlerIndexBeltDown[type]);
            obj.attr("data-active",1); 
            var objIcon=obj.find(".iconJS");
            var step_blink=0,interval=40,step_blink_max=Math.round(1000/interval*2),blink_val=-1;
            var step=0,dir=-1,step_max=Math.round(step_blink_max/2),dist=35;
            _externalTimeHandler.set(this.timeHandlerIndexBeltDown[type],function(){
                step_blink=(step_blink+1)%(step_blink_max);
                var blink_tmp=0;
                if(step_blink>step_blink_max/2){
                    blink_tmp=1;
                }
                if(blink_tmp!=blink_val){
                    blink_val=blink_tmp;
                    obj.attr({"data-blink":blink_val});
                }
                if(step>=step_max || step<=0){
                    dir=dir*(-1);
                }
                objIcon.css("top",Math.round(-step/step_max*dist)+"px");
                
                step+=dir;
                
            },interval,function(){
               obj.attr({"data-active":0,"data-blink":0}); 
               objIcon.css("top",0);
            });
        }
        if(state_str=="stop"){
            _externalTimeHandler.clear(this.timeHandlerIndexBeltDown[type]);
        }
        
    },
    makeBeltAnimation:function(){
//        if(this.data_old['skill_energy']!=this.data["skill_energy"]){
//            $.qLog("<br>"+this.data_old['skill_energy']+" "+this.data["skill_energy"])
//        }
        var set_old=this.takeBeltSize(this.data_old),set_cur=this.takeBeltSize(this.data);
        var i,obj;
        if(!this.wasUpdated){
            for(i in set_cur){
                obj=this.profObj.find("#beltEnergyBars .belt[data-type='"+i+"']");
                obj.width(Math.round(set_cur[i]));
                if(set_cur[i]==0){
                    obj.find(".iconNumber,.icon").hide();
                }
            }
        }
        var thObj=this;
        function addAnim(key,val_old,val_new){
            var indexAnim=thObj.timeHandlerIndex["energy_belts"][key][1],
            indexQueue=thObj.timeHandlerIndex["energy_belts"][key][0];
            _externalTimeHandler.queueAdd(indexQueue,function(){
                var step=0,step_max,px_on_step=4,
                obj=thObj.profObj.find("#beltEnergyBars .belt[data-type='"+key+"']"),
                objDet=obj.find(".iconNumber,.icon"),width_old=-1;
                step_max=Math.max(Math.abs(val_old-val_new)/px_on_step,1);
                _externalTimeHandler.set(indexAnim,function(){
                    step++;
                    var width_new;
                    if(step>=step_max){
                        width_new=val_new;
                        _externalTimeHandler.clear(indexAnim);
                        _externalTimeHandler.queueTrigger(indexQueue);
                    }
                    else{
                        width_new=val_old+(val_new-val_old)*step/step_max;
                    }
                    obj.width(Math.round(width_new));
                    if(width_old!=-1){
                        if(width_new>=30 && width_old<30){
                            objDet.fadeIn(500);
                        }
                        if(width_new<30 && width_old>=30){
                            objDet.fadeOut(500);
                        }
                    }
                    else if(width_new<30){
                        objDet.fadeOut(500);
                    }
                    width_old=width_new;
                    
                },50);
            });
            if(!_externalTimeHandler.isIndexSet(indexAnim)){
                 _externalTimeHandler.queueTrigger(indexQueue);
            }
            else{
                
            }
        }
        if(this.wasUpdated){
            for(i in set_cur){
                if(set_cur[i]!=set_old[i]){
                    addAnim(i,set_old[i],set_cur[i]);
                }
            }
        }
    },
    takeData:function(name){
        if(name=="premium_all"){
            return this.data.premium+this.data.premium_free;
        }
        if(name=="cash"){
            return _cashObjSet.takeCash();
        }
        return this.data[name];
    },
    updateMission:function(mission_flag){
        mission_flag=intval(mission_flag);
        var step=0;
        if(mission_flag && !_externalTimeHandler.isIndexSet(this.timeHandlerIndex["mission"])){
            
            var obj=this.profObj.find(".missionRow"),step_max=26,objImg=this.profObj.find(".missionRow .img");
            var rot_angle=30,rot_dir=1,rot_step_max=10,rot_step=Math.round(rot_step_max/2);
            _externalTimeHandler.set(this.timeHandlerIndex["mission"],function(){
                step=(step+1)%step_max;
                if(step<=step_max/2){
                    obj.addClass("blink");
                }
                else{
                    obj.removeClass("blink");
                }
                rot_step+=rot_dir;
                if(rot_step>=rot_step_max || rot_step<=0){
                    rot_dir*=-1;
                }
                objImg.cssrotate(rot_angle*rot_step/rot_step_max-0.5*rot_angle);
            },40,function(){
                obj.removeClass("blink");
                objImg.cssrotate(0);
            });
        }
        else if(!mission_flag){
            _externalTimeHandler.clear(this.timeHandlerIndex['mission']);
        }
    },
    takeBeltSizeCur:function(){
        return this.takeBeltSize(this.data);
    },
    takeBeltSize:function(data){
        var width_all=330;
        var width_min=30;
        var arr_keys=["position","skill","cash","fight"],i,bum;
        var width_ready={},energy_busy=0;
        var energy_max=intval(data.energy_max);
        for(i in arr_keys){
            bum=arr_keys[i];
            energy_busy+=data[bum+"_energy"];
            if(data[bum+"_energy"]>0){
                width_ready[bum]=width_min;
                width_all-=width_ready[bum];
            }
            else{
                width_ready[bum]=0;
            }
        }
        
        for(i in arr_keys){
            bum=arr_keys[i];
            if(data[bum+"_energy"]>0){
               width_ready[bum]+=data[bum+"_energy"]/energy_max*width_all;
            }
        }
        return width_ready;
        //"energy_max",position_energy,skill_energy,cash_energy
    },
    setData:function(name,val){
        var type_of=typeof this.data[name],is_init=0;
        if(type_of=="undefined"){
            is_init=1;
            if(typeof val=="object"){
                this.data_old[name]=copyObj(val);
            }
            else{
                this.data_old[name]=val;
            }
            
        }
        
        var subs=name.substr(-4);
        if(subs!="_str" && subs!="_obj" && subs!="_flo"){
           val=intval(val);
        }
        if(subs=="_flo"){
            val=parseFloat(val);
        }
        this.data[name]=val;
        
        
        if(name=="speed_bonus_global_flo"){
            if(this.data_old[name]!=val){
                _semaphoreXHR.makeAfterClear(function(){
                    _eventHandler.trigger("speed_bonus_global");
                });
            }
            if(val<10){
                val=numberFormat(val,0,1,1);
            }
            else{
                var tmp=Math.round(val).toString().length;
                tmp=tmp%3;
                if(tmp==0){
                    tmp=3;
                }
                if(tmp==1){
                    val=numberFormat(val,1,1);
                }
                else{
                    val=numberFormat(val,0,1);
                }
            }
        }
        
        if(this.data_old[name]!=this.data[name] || is_init){
            var val_str=val;
            if(type_of=="number" && name!="speed_bonus_global_flo" && name!="premium_all"){
                val_str=numberFormat(val);
            }
            this.profObj.find(".putData[data-type='"+name+"']").html(val_str);
            if(name=="mission_flag"){
                this.updateMission(val);
            }
        }
        
        
    },
    takeBonusTime:function(){
        var res=copyObj(this.bonusTimeObj);
        res.normal_have=parseFloat(res.normal_have);
        res.premium_have=intval(res.premium_have);

        var bonus_cur=res.normal_have*res.premium_have;
        var normal_bonus_max_percent=(((res.normal_have+res.normal_can_add)*res.premium_have)/bonus_cur-1)*100;
        normal_bonus_max_percent=Math.floor(normal_bonus_max_percent*10)/10;
        var premium_bonus_max_percent=(((res.premium_have+res.premium_can_add)*res.normal_have)/bonus_cur-1)*100;
        premium_bonus_max_percent=Math.floor(premium_bonus_max_percent*10)/10;
//        var need_percent=0;
//        if(res.need_bonus>bonus_cur){
//            need_percent=Math.round(((res.need_bonus/bonus_cur)-1)*100/2);
//            need_percent=Math.max(0,need_percent);
//            $.qLog(need_percent+" ");
//        }
        
        var type="";
        if(normal_bonus_max_percent>=100 || (normal_bonus_max_percent>0 && premium_bonus_max_percent==0)){
            type="normal";
        }
        else if(premium_bonus_max_percent>0){
            type="premium";
        }
//        var q_id=getQuestId();
//        if(bonus_cur>=res.need_bonus || (q_id<=21 && q_id!=-1)){
//            if(res.need_bonus>10000000 && type=="premium"){
//                
//            }
//            else{
//                type="";
//            }
//        }
        if(type=="normal" && normal_bonus_max_percent<50){
            type="";
        }
        res.type=type;
        function chooseColor(val){
            if(val<=100){
                return "low";
            }
            else if(val<=300){
                return "medium";
            }
            return "high";
        }
        var normal_bonus_show=normal_bonus_max_percent;
        var premium_bonus_show=premium_bonus_max_percent;
        if(premium_bonus_show<100 && premium_bonus_max_percent>=100){
            premium_bonus_show=100;
        }
        else if(premium_bonus_show>700 && premium_bonus_max_percent>=700){
            premium_bonus_show=700;
        }
        else if(premium_bonus_show>100 && premium_bonus_max_percent>=300){
            premium_bonus_show=300;
        }
        if(normal_bonus_show>100 && premium_bonus_show>100){
            premium_bonus_show=100;
        }
        
        res.normal={
            "bonus_show":normal_bonus_show,
            "color":chooseColor(normal_bonus_show),
            "bonus_max":normal_bonus_max_percent,
            "action":"premiumreset",
            "img":_IMG_SERV+"/gfx/place/premiumshop/big_icons/multireset.png"
        };
        res.premium={
            "bonus_show":premium_bonus_show,
            "color":chooseColor(premium_bonus_show),
            "bonus_max":premium_bonus_max_percent,
            "action":"premiumbonus",
            "img":_IMG_SERV+"/gfx/place/premiumshop/big_icons/multitime.png"
        };
        
        return res;
    }
};
_myProfile=new myProfile();
$(function(){
    _myProfile.init();
});
